import { useEffect, useRef } from "react";
import { todayISO } from "./intl";

/** Keeps a date that was left on "today" on today: when Melbourne's day ticks over (refocus or each minute), move it forward. */
export function useRollingToday(value, setValue) {
  const today = useRef(todayISO());
  const latest = useRef(value);
  latest.current = value;
  useEffect(() => {
    const tick = () => {
      const now = todayISO();
      if (now === today.current) return;
      if (latest.current === today.current) setValue(now);
      today.current = now;
    };
    const id = setInterval(tick, 60000);
    window.addEventListener("focus", tick);
    document.addEventListener("visibilitychange", tick);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", tick);
      document.removeEventListener("visibilitychange", tick);
    };
  }, [setValue]);
}
